export default __webpack_public_path__ + "static/media/arrows.e2a0d896.png";